import { Component } from "@builder.io/sdk";

export const faqsCiAppConfig: Component = {
  name: "FAQs CI App",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "faqs",
      advanced: true,
      helperText: "HTML ID attribute for the section element",
    },
    {
      name: "className",
      type: "string",
      advanced: true,
      helperText: "Additional CSS classes to apply to the section",
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Frequently Asked Questions",
      helperText: "Main heading text for the FAQs section",
    },
    {
      name: "image",
      type: "object",
      defaultValue: {
        src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Ff85fa30ca2ef4fa7bb8ef1f9d7dd2129",
        alt: "CI App FAQ Image",
      },
      helperText: "Image to display in the FAQs section",
      subFields: [
        {
          name: "src",
          type: "file",
          allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
          helperText: "Source URL for the image",
          friendlyName: "Image",
        },
        {
          name: "alt",
          type: "string",
          helperText: "Alt text for accessibility",
          friendlyName: "Alt Text",
        },
      ],
    },
    {
      name: "items",
      type: "list",
      helperText: "List of FAQ questions and answers",
      defaultValue: [
        {
          header: "What core features are available on the CI App right now?",
          content:
            "The app currently offers shift scheduling, real-time matching, 24/7 concierge support, team chat, geofencing for clock-ins/outs, and shift rating tools.",
        },
        {
          header: "Can the app help during last-minute cancellations?",
          content:
            "Yes. The app can initiate automated search and notification for replacements, especially helpful during early morning hours.",
        },
        {
          header:
            "How does communication work between the facility and Care Indeed through the app?",
          content:
            "Facilities use the in-app chat and concierge support for seamless updates, file sharing, and follow-ups—eliminating the need for multiple communication channels.",
        },
        {
          header:
            "Can the CI App be customized to suit our facility's operations?",
          content:
            "Yes! The app can be tailored with operational checklists, caregiver notes, and documentation tools that align with your internal workflows.",
        },
        {
          header: "Is the CI App accessible via both desktop and mobile?",
          content:
            "Yes. The app is fully functional on desktop and mobile (via web browser and mobile app), giving your team flexibility depending on where they're working.",
        },
      ],
      subFields: [
        {
          name: "header",
          friendlyName: "Question",
          type: "string",
          helperText: "The question text for this FAQ item",
        },
        {
          name: "content",
          friendlyName: "Answer",
          type: "longText",
          helperText: "The detailed answer for this FAQ item",
        },
      ],
    },
  ],
};
